import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IServiceEventMappingModel } from '../../../models/index';
import {
  DeleteServiceEventMappingPayload,
  ServiceEventMappingState,
  UpdateServiceEventMappingPayload
} from '../../actions/types/services/ServiceEventsMappingTypes';

/**
 * Initial Service Oprations in store
 */
const initialState: ServiceEventMappingState = {
  ingressEventMappingList: [],
  status: false,
  statusMessage: ''
};

const serviceEventMappingSlice = createSlice({
  name: 'serviceEventMapping',
  initialState,
  reducers: {
    addServiceEventMapping: (
      state,
      actions: PayloadAction<IServiceEventMappingModel>
    ) => {
      state.ingressEventMappingList.push(actions.payload);
    },
    deleteServiceEventMapping: (state, actions: PayloadAction<DeleteServiceEventMappingPayload>) => {
      state.ingressEventMappingList.splice(actions.payload.index, 1);
      state.statusMessage = actions.payload.statusMessage;
    },
    updateServiceEventMapping: (state, actions: PayloadAction<UpdateServiceEventMappingPayload>) => {
      state.ingressEventMappingList.splice(actions.payload.index, 1, actions.payload.serviceEventMapping);
    },
    clearServiceEventMapping: (state) => {
      state.ingressEventMappingList = initialState.ingressEventMappingList;
      state.status = false;
    },
    duplicateServiceEventMaping: (state, actions) => {
      state.status = actions.payload;
    },
    statusMessageClearMaping: (state) => {
      state.statusMessage = '';
    }
  }
});
export const {
  addServiceEventMapping,
  deleteServiceEventMapping,
  updateServiceEventMapping,
  clearServiceEventMapping,
  duplicateServiceEventMaping,
  statusMessageClearMaping
} = serviceEventMappingSlice.actions;
export default serviceEventMappingSlice.reducer;
